// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"PP-z","categoryName":"QP-z","categoryNameSearchHeader":"RP-z","categoryContent":"SP-z","bottomAligned":"TP-z","image":"UP-z","imageNoBackground":"VP-z"};